import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';

const titleElement = document.querySelector('title');
if (titleElement) {
    titleElement.innerHTML = environment.title;
}
const favicon: HTMLLinkElement | null = document.querySelector('#appFavicon');
if(favicon) {
    favicon.href = environment.logoPath;
}

const splashScreenImg: HTMLImageElement | null = document.querySelector('#splash-screen');
if(splashScreenImg) {
    splashScreenImg.src = environment.logoPath;
    splashScreenImg.alt = environment.logoAlt;
}

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).then(() => {
    if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('ngsw-worker.js').catch(err => console.error('Service Worker registration failed: ', err));
    }
}).catch((err) => console.error(err));


